/* Launch countdown ticker for snippets/lto-countdown.liquid ([data-lto-cd]).
   Liquid renders the value at page-render time; this keeps it live (one shared
   1s interval) and applies the configured end behaviour:
     hide          → the whole element is hidden
     replace_all   → the element's text becomes data-ended-text
     replace_timer → only the timer becomes data-ended-text
   Elements are re-queried every tick, so slider clones (slick) and sections
   re-rendered in the theme editor are picked up without re-binding. */
(function () {
  'use strict';
  if (window.__ltoCountdown) return;
  window.__ltoCountdown = true;

  function parseTarget(s) {
    if (!s) return NaN;
    // Accept "+0530" as well as "+05:30" (Liquid %z prints the former).
    var iso = String(s).trim().replace(' ', 'T').replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    return Date.parse(iso);
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  function render(el, left) {
    var fmt = el.getAttribute('data-format') || 'units';
    var secs = el.getAttribute('data-seconds') !== 'false';
    var t = Math.max(0, Math.floor(left / 1000));
    var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
    var dd = d > 99 ? String(d) : pad(d);
    if (fmt === 'clock') return (d > 0 ? dd + ':' : '') + pad(h) + ':' + pad(m) + (secs ? ':' + pad(s) : '');
    if (fmt === 'words') return (d > 0 ? plural(d, 'day', 'days') + ' ' : '') + plural(h, 'hr', 'hrs') + ' ' + plural(m, 'min', 'mins') + (secs ? ' ' + plural(s, 'sec', 'secs') : '');
    if (fmt === 'boxes') {
      var box = function (v, l) { return '<span class="lto-cd__box"><b>' + v + '</b><i>' + l + '</i></span>'; };
      return (d > 0 ? box(dd, 'Days') : '') + box(pad(h), 'Hrs') + box(pad(m), 'Mins') + (secs ? box(pad(s), 'Secs') : '');
    }
    return (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm' + (secs ? ' ' + pad(s) + 's' : '');
  }

  function end(el) {
    if (el.__ltoEnded) return;
    el.__ltoEnded = true;
    var mode = el.getAttribute('data-ended-mode') || 'hide';
    var text = el.getAttribute('data-ended-text') || '';
    el.classList.add('lto-cd--ended');
    if (mode === 'hide' || !text) { el.hidden = true; el.style.display = 'none'; }
    else if (mode === 'replace_all') { el.textContent = text; }
    else {
      var timer = el.querySelector('[data-lto-cd-timer]');
      if (timer) timer.textContent = text;
    }
    try { el.dispatchEvent(new CustomEvent('lto:countdown-end', { bubbles: true })); } catch (e) {}
  }

  function tick() {
    var now = Date.now();
    var els = document.querySelectorAll('[data-lto-cd]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__ltoEnded) continue;
      if (el.__ltoTarget === undefined) el.__ltoTarget = parseTarget(el.getAttribute('data-target'));
      if (isNaN(el.__ltoTarget)) continue; // unreadable date: leave the server-rendered text
      var left = el.__ltoTarget - now;
      if (left <= 0) { end(el); continue; }
      var timer = el.querySelector('[data-lto-cd-timer]');
      if (!timer) continue;
      var html = render(el, left);
      if (timer.__ltoLast !== html) {
        if (el.getAttribute('data-format') === 'boxes') timer.innerHTML = html; else timer.textContent = html;
        timer.__ltoLast = html;
      }
    }
  }

  function start() { tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // Theme editor: re-rendered sections bring fresh elements; tick at once.
  document.addEventListener('shopify:section:load', tick);
})();
